import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import AuthService from 'library/authService/auth-service';
import config from './config';

const handlePrepareData = ({ rosterId, validations, start }) => ({
  validation: validations.key,
  boundary_start: start[0],
  boundary_end: start[1],
  request_user_id: AuthService.whoami().id,
  roster_version_id: rosterId
});

const ValidationTasks = ({
  rosterId, canAdmin, visibleTimeStart, visibleTimeEnd
}) => (
  <Inner
    onPrepareData={params => handlePrepareData({
      ...params,
      rosterId
    })}
    canAdmin={canAdmin}
    reducer={{
      item: REDUCER_KEY.validationTask,
      list: REDUCER_KEY.validationTasks
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          roster_version__id: [rosterId]
        },
        sorter: {
          field: 'triggered_on',
          order: 'descend'
        },
        onRowClick: () => {
        }
      },
      detail: {
        ...config.detail,
        parent: {
          parent_roster_id: rosterId
        },
        component: props => config.detail.component({
          ...props,
          visibleTimeStart,
          visibleTimeEnd
        })
      }
    }}
    defaultSize="250px"
    messaging={{
      save: {
        failure: () => 'Saving failed',
        success: () => 'Saving was successful'
      }
    }}
  />
);

ValidationTasks.propTypes = {
  rosterId: PropTypes.number,
  canAdmin: PropTypes.bool.isRequired,
  visibleTimeStart: PropTypes.object.isRequired,
  visibleTimeEnd: PropTypes.object.isRequired
};

ValidationTasks.defaultProps = {
  rosterId: null
};

export default ValidationTasks;
